export enum ServerEndpoint {
  LOGIN = 'auth/in',
  LOGIN_WITH_GOOGLE = 'auth/ingsi',
  LOGIN_CHECK = 'auth/check',
  SIGN_UP = 'sign/new',
  SIGN_UP_WITH_GOOGLE = 'sign/google',
  RESET_PASSWORD = 'auth/resetpswd',
  PROFILE_UPDATE_IMAGE = 'webapp/profile/image',
  CONTACT = 'public/contact',
  GENERATE_REQUEST = 'api/req',
  SERVICES = 'webApp/services/list',
  RAW_USER_USAGE = 'webApp/rawdata/usage',
  RAW_USER_TRAFFIC = 'webApp/rawdata/list',
  RAW_USER_CAPACITY = 'webApp/rawdata/credit',
  SUBSCRIPTIONS = 'webApp/subs/list',
  SUBSCRIPTIONS_SUBSCRIBE = 'webApp/subs/sub',
  RECIPLO_AI_PROMPT = 'webApp/rpai/prompt',
  INGREDIENTS = 'ingrid/grep',
  INGREDIENTS_ANALYZE = 'webapp/recipe/analyze',
  RECEPIES = 'public/recipes',
  RECIPES_USER = 'webapp/recipe/list',
  RECEPIES_SUGGEST = 'webapp/recipe/suggest',
  RECEPIES_GENERATE = 'webapp/recipe/generate',

}

export enum AutoCompleteEndPoint {
  USE_NAME = 'ac/name',
}

export type ApiEndpoint = ServerEndpoint | AutoCompleteEndPoint;
